<template>
  <div class="single-answer">
    <div class="question-title" id='contentItem' ref='contentItem'>Question {{question.questionNo}}</div>
    <div class="question-part">
      <div class="que-row">
        <div class="que-col-1">&nbsp;</div>
        <div class="que-col-2">
          <div class="ck-editor">
            <ckeditor
			:read-only="isEditable"
              :editorUrl="editorURL"
              v-model="question.question_text"
              :config="{contentsCss: ['body {font-size: 16px;}'],toolbarStartupExpanded:false}"
            ></ckeditor>
          </div>
        </div>
      </div>
    </div>

    <div class="col-part">
      <div class="right-que-part">
        <div class="question-title">Column I</div>
        <div v-for="(opt,qindex) in question.options_abc" :key="qindex" class="que-row">
          <div class="que-col-1">
            <span class="opction-text">{{opt.index}}</span>
          </div>
          <div class="que-col-2">
            <div class="ck-editor">
              <ckeditor
			  :read-only="isEditable"
                :editorUrl="editorURL"
                v-model="opt.option_text"
                :config="{contentsCss: ['body {font-size: 16px;}'],toolbarStartupExpanded:false,startupFocus:false}"
              ></ckeditor>
            </div>
          </div>
        </div>

        <div class="que-row add-sl-opction">
          <div class="que-col-1">&nbsp;</div>
          <div class="que-col-2">
            <div v-if="shouldShowAddABCoption" class="add-opction">
              <div  @click="addNewOption(1)" class="circle-icon">
                <v-icon>mdi-plus-circle</v-icon>
                <span>Add Row</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="left-que-part">
        <div class="question-title">Column II</div>
        <div v-for="(opt,qindex) in question.options_pqr" :key="qindex" class="que-row">
          <div class="que-col-1">
            <span class="opction-text">{{opt.index}}</span>
          </div>
          <div class="que-col-2">
            <div class="ck-editor">
              <ckeditor
			  :read-only="isEditable"
                :editorUrl="editorURL"
                v-model="opt.option_text"
                :config="{contentsCss: ['body {font-size: 16px;}'],toolbarStartupExpanded:false,startupFocus:false}"
              ></ckeditor>
            </div>
          </div>
        </div>
        <div class="que-row add-sl-opction">
          <div class="que-col-1">&nbsp;</div>
          <div class="que-col-2">
            <div v-if="shouldShowAddPQRoption" class="add-opction">
              <div @click="addNewOption(2)" class="circle-icon">
                <v-icon>mdi-plus-circle</v-icon>
                <span>Add Row</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="question-title">Answer</div>
    <div class="que-row matrix-top">
      <div class="que-col-1">&nbsp;</div>
      <div class="que-col-2">
        <div class="matrix-match-block">
          <div class="matrix-col">
            <div class="mt-data">&nbsp;</div>
            <div
              v-for="(opt,qindex) in question.options_abc"
              :key="qindex"
              class="mt-data mt-label"
            >{{opt.index}}</div>
          </div>
          <div v-for="(pqr,opindex) in question.options_pqr" :key="opindex" class="matrix-col">
            <div class="mt-data mt-label">{{pqr.index}}</div>
            <div v-for="(abc,qindex) in question.options_abc" :key="qindex" class="mt-data">
              <div class="check-cust">
                <div class="private-radio">
                  <input
                    type="checkbox"
                    :checked="abc.correct_answer.includes(pqr.index)"
                    @change="onChangeInput($event,pqr,abc)"
                  />
                  <i
                    v-if="abc.correct_answer.includes(pqr.index)"
                    aria-hidden="true"
                    class="v-icon mdi mdi-checkbox-marked theme--light"
                  ></i>
                  <i
                    v-else
                    aria-hidden="true"
                    class="v-icon mdi mdi-checkbox-blank-outline theme--light"
                  ></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- <div class="question-title">Hints</div>
        <div v-for="(hint,hi) in question.hints" :key="hi" class="ans-part">
            <div class="que-row">
                <div class="que-col-1">
                    <span class="delete-icon">{{hi+1}}.<v-icon   @click="removeHint" >mdi-delete-circle</v-icon></span>
                </div>
                <div class="que-col-2">
                    <div class="ck-editor">
                        <ckeditor :editorUrl="editorUrl"  v-model="hint.text" :config="{contentsCss: ['body {font-size: 16px;}'],toolbarStartupExpanded:false,startupFocus:false}"></ckeditor>
                    </div>
                </div>
            </div>
        </div>
        <div class="que-row add-sl-opction">
            <div class="que-col-1">&nbsp;</div>
            <div class="que-col-2">
                <div v-if="shouldShowAddHint" @click="addNewHint()" class="add-opction">
                    <div class="circle-icon">
                        <v-icon>mdi-plus-circle</v-icon> 
                        <span>Add Hint</span>
                    </div>
                </div>
            </div>
    </div>-->

    <div class="question-title">Solution</div>
    <div class="ans-part">
      <div class="que-row">
        <div class="que-col-1">&nbsp;</div>
        <div class="que-col-2">
          <div class="ck-editor">
            <ckeditor
			:read-only="isEditable"
              :editorUrl="editorURL"
              v-model="question.solution"
              :config="{contentsCss: ['body {font-size: 16px;}'],toolbarStartupExpanded:false,startupFocus:false}"
            ></ckeditor>
          </div>
        </div>
      </div>
    </div>
    <div class="right-align">
      <v-btn
      v-if="showNextButton"
        @click="onNextQuestion({question})"
        class="right-btn cust-btn"
        color="primary"
      >{{question.btnText}}</v-btn>
    </div>
  </div>
</template> 
<script>
export default {
  name: "MatrixMatch",
  props: ['question','onNextQuestion', 'showNextButton','isEditable'],
  data() {
    return {};
  },
  mounted() {
    this.setDefaultData();
  },
  methods: {
    onChangeInput(e, pqr, abc) {
      if (e.target.checked) {
        if (!abc.correct_answer.includes(pqr.index)) {
          let op = abc.correct_answer.split("##");
          abc.correct_answer = "";
          if (op.length > 0) {
            op.map((opt, idx) => {
              if (idx > 0) {
                abc.correct_answer = abc.correct_answer + "##" + opt;
              } else {
                abc.correct_answer = opt;
              }
            });
          }
          if (abc.correct_answer.trim().length > 0) {
            abc.correct_answer = abc.correct_answer + "##" + pqr.index;
          } else {
            abc.correct_answer = pqr.index;
          }
        }
      } else {
        if (abc.correct_answer.includes(pqr.index)) {
          let op = abc.correct_answer.split("##");
          abc.correct_answer = "";
          if (op.length > 0) {
            op.map((opt, idx) => {
              if (pqr.index != opt) {
                if (idx > 0) {
                  abc.correct_answer = abc.correct_answer + "##" + opt;
                } else {
                  abc.correct_answer = opt;
                }
              }
            });
          }
        }
      }
    },
    addNewOption(column) {
		if(!this.isEditable){
			if (column === 1) {
					this.question.options_abc.push({
					index: this.OPTIONS_ABC[this.question.options_abc.length],
					option_text: "",
					correct_answer: "P",
					column: column
					});
				} else if (column === 2) {
					this.question.options_pqr.push({
					index: this.OPTIONS_PQR[this.question.options_pqr.length],
					option_text: "",
					correct_answer: "",
					column: column
					});
				}
		}
      
    },
    addNewHint() {
      this.question.hints.push({
        text: ""
      });
    },
    removeHint(index) {
      this.question.hints.splice(index, 1);
    },
    setDefaultData() {
      this.question.hints =
        this.question && this.question.hints && this.question.hints.length
          ? this.question.hints
          : [{ text: "" }];
      this.question.options_abc =
        this.question &&
        this.question.options_abc &&
        this.question.options_abc.length
          ? this.question.options_abc
          : [
              {
                index: this.OPTIONS_ABC[0],
                option_text: "",
                column: 1,
                correct_answer: ""
              },
              {
                index: this.OPTIONS_ABC[1],
                option_text: "",
                column: 1,
                correct_answer: ""
              }
            ];
      this.question.options_pqr =
        this.question &&
        this.question.options_pqr &&
        this.question.options_pqr.length
          ? this.question.options_pqr
          : [
              {
                index: this.OPTIONS_PQR[0],
                option_text: "",
                column: 2,
                correct_answer: ""
              },
              {
                index: this.OPTIONS_PQR[1],
                option_text: "",
                column: 2,
                correct_answer: ""
              }
            ];
    }
  },
  computed: {
    shouldShowAddABCoption() {
      return this.question.options_abc.length < this.OPTIONS_ABC.length;
    },
    shouldShowAddPQRoption() {
      return this.question.options_pqr.length < this.OPTIONS_PQR.length;
    },
    shouldShowAddHint() {
      return this.question.hints.length < this.OPTIONS_ABC.length;
    }
  },
  watch: {
    question(val) {
      this.setDefaultData();
       document.getElementById('contentItem').scrollIntoView();
    }
  }
};
</script>
